/**
 * Fetch subscribers list with filters.
 */
export const fetchSubscribersList = async (filters = {}, pageNumber = 0) => {
  const requestBody = {
    user_id: filters.user_id != 0 ? filters.user_id : null,
    name: filters.name || null,
    email: filters.email || null,
    phone: filters.phone || null,
    region_id: filters.regionId || null,
    decoder_id: filters.decoderId || null,
    limit: 10,
    offset: pageNumber * 10,
  };

  try {
    const response = await fetch(`/api/user/list`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });
    if (!response.ok) throw new Error("Failed to fetch subscribers");
    const data = await response.json();
    return data || {};
  } catch (error) {
    console.error(error);
    return {};
  }
};

